import React from "react";

import { Outlet } from "react-router-dom";

const StockTemplate = () => {
  return <Outlet />;
};

export default StockTemplate;
